<arm-side-nav [items]="administrationItems" [title]="'Administration'" class="settings"></arm-side-nav>
